<template>
<div>
<div class="plane-container" v-on:click="plane" :class="{hidePlane: planeStat === true || $store.state.compass === true}">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  width="1131.53px" height="379.304px" viewBox="0 0 1131.53 379.304" enable-background="new 0 0 1131.53 379.304"
  xml:space="preserve" class="plane">
  <polygon fill="#fff" points="72.008,0 274.113,140.173 274.113,301.804 390.796,221.102 601.682,367.302 1131.53,0.223  "/>
  <polygon fill="#C4C4C3" points="1131.53,0.223 274.113,140.173 274.113,301.804 390.796,221.102   "/>
  </svg>
</div>

<div class="main-rain back-row-toggle splat-toggle">
  <div class="rain front-row">
    <div v-for="n in randNumb" class='drop' v-bind:style="drop1(n, 'first')">
      <div class='stem' v-bind:style="drop1(n, 'second')"></div>
      <div class='splat' v-bind:style="drop1(n, 'second')"></div>
    </div>
  </div> 

</div>

</div>

</template>

<script>
  import _ from 'underscore'

  export default {
    name: 'rainSplash',
    data () {
    return {
      increment: null,
      randNumb: null,
      planeStat: false
      }
    },
    computed: {
      percentage () {
        return 100/this.randNumb
      }, 
      arr () {
        const arr = Array.from(Array(this.randNumb).keys())
        return arr
      }, 
      arrayVal () {
        const arr = this.arr
        // const arrF = []
        for (var i = 0; i < arr.length; i++)
        {   
            const randoHundo = (Math.floor(Math.random() * (98 - 3) + 1))
            const randoFiver = (Math.floor(Math.random() * (5 - 3) + 2))
            arr[i] = [randoHundo, randoFiver] 
        }
        return arr
      }
    },
    mounted: function () {
      this.randNumb = this.randRange(40, 100)
    },
    methods: {
      plane: function (event) {
        this.planeStat = true
      },
      randRange: function (minNum, maxNum) {
        return (Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum)
      },
      drop1: function (num, pas) {
        const randoHundo = (Math.floor(Math.random() * (98 - 3) + 1))
        const randoFiver = (Math.floor(Math.random() * (5 - 3) + 2))
        const increment = num * this.percentage

        const selectRandom = this.arrayVal[num]
        const values = _.values(selectRandom)
        const randoHundoSync = values[0]
        const randoFiverSync = values[1]

        if (increment > 38 && increment < 62 && pas === 'first' && this.planeStat === false && this.$store.state.compass === false) {
          return {
            left: increment + '%', 
            bottom: randoFiver + randoFiver - 1 + 156 + '%', 
            animationDelay: '0.' + randoHundo + 's', 
            animationDuration: '0.5' + randoHundoSync + 's',
          }
        } else if (pas === 'first'){
          return {
            left: increment + '%', 
            bottom: randoFiver + randoFiver - 1 + 86 + '%', 
            animationDelay: '0.' + randoHundoSync + 's', 
            animationDuration: '0.5' + randoHundoSync + 's',
          }
        } else {
          return {
            animationDelay: '0.' + randoHundoSync + 's', 
            animationDuration: '0.5' + randoHundoSync + 's',
          }
        }
      }
    }
  }
</script>
  
<style lang="less">
@import "../../styles/global.less";

.main-rain {
  height: 100vh;
  width: 100vw;
  display: block;

  margin: 0;
  overflow: hidden;
  // background: linear-gradient(to bottom, #202020, #111119);
  position: fixed;
  user-select: none;
  pointer-events: none;

  z-index: 1000000;
  top: 0px;
}

.rain {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.rain.back-row {
  display: none;
  z-index: 1;
  bottom: 60px;
  opacity: 0.5;
}

.main-rain.back-row-toggle .rain.back-row {
  display: block;
}

.drop {
  position: absolute;
  bottom: 100%;
  width: 15px;
  height: 120px;
  pointer-events: none;
  animation: drop 0.5s linear infinite;
}

@keyframes drop {
  0% {
    transform: translateY(0vh);
  }
  75% {
    transform: translateY(90vh);
  }
  100% {
    transform: translateY(90vh);
  }
}

.stem {
  width: 1px;
  height: 60%;
  margin-left: 7px;
  background: linear-gradient(to bottom, rgba(0,191,255, 0), rgba(0,191,255, 0.5));
  animation: stem 0.5s linear infinite;
}

@keyframes stem {
  0% {
    opacity: 1;
  }
  65% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.splat {
  width: 15px;
  height: 10px;
  border-top: 2px dotted rgba(0,191,255, 0.8);
  border-radius: 50%;
  opacity: 1;
  transform: scale(0);
  animation: splat 0.5s linear infinite;
  display: none;
}

.main-rain.splat-toggle .splat {
  display: block;
}

@keyframes splat {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  80% {
    opacity: 1;
    transform: scale(0);
  }
  90% {
    opacity: 0.5;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}

.toggles {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

.toggle {
  position: absolute;
  left: 20px;
  width: 50px;
  height: 50px;
  line-height: 51px;
  box-sizing: border-box;
  text-align: center;
  font-family: sans-serif;
  font-size: 10px;
  font-weight: bold;
  background-color: rgba(0,191,255, 0.5);
  color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle:hover {
  background-color: rgba(255, 255, 255, 0.25);
}

.toggle:active {
  background-color: rgba(255, 255, 255, 0.3);
}

.toggle.active {
  background-color: rgba(255, 255, 255, 0.4);
}

.splat-toggle {
  // top: 20px;
}

.back-row-toggle {
  // top: 90px;
  line-height: 12px;
  // padding-top: 14px;
}

.single-toggle {
  top: 160px;
}

.main-rain.single-toggle .drop {
  display: none;
}

.main-rain.single-toggle .drop:nth-child(10) {
  display: block;
}

// Plane
.plane-container {
  width: 320px;
  z-index: 3;
  position: fixed;
  margin-top: 18vh;

  left: 50%;
  transform: translateX(-50%);

  transition: opacity .5s .25s;
  cursor: pointer;

  -webkit-animation: scoping 2.5s ease-in  infinite;
  -moz-animation: scoping 2.5s ease-in  infinite;
  animation: scoping 2.5s  ease-in infinite;

  -webkit-animation-direction: alternate;
  -moz-animation-direction: alternate;
  animation-direction: alternate;
}
 
.plane {
  width: 320px;
  height: auto;

  -webkit-animation: soaring 4s ease-out infinite;
  -moz-animation: soaring 4s  ease-out infinite;
  animation: soaring 4s  ease-out infinite;

  -webkit-animation-direction: forwards;
  -moz-animation-direction: forwards;
  animation-direction: forwards;
}

.hidePlane {
  pointer-events: none;
  opacity: 0;
}


@keyframes scoping {
  0% {
    -webkit-transform: translate(-48%, 0px);
    -moz-transform: translate(-48%, 0px);
    transform: translate(-48%, 0px);
  }
  50% {
    -webkit-transform: translate(-54%, 30px);
    -moz-transform: translate(-54%, 30px);
    transform: translate(-54%, 30px);
  }
  100% {
    -webkit-transform: translate(-48%, 60px);
    -moz-transform: translate(-48%, 60px);
    transform: translate(-48%, 60px);
  }
}

@keyframes soaring {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  40% {
    -webkit-transform: rotate(15deg);
    -moz-transform: rotate(15deg);
    transform: rotate(15deg);
  }
  50% {
    -webkit-transform: rotate(15deg);
    -moz-transform: rotate(15deg);
    transform: rotate(15deg);
  }
  60% {
    -webkit-transform: rotate(-10deg);
    -moz-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
  70% {
    -webkit-transform: rotate(-10deg);
    -moz-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@media screen and (max-width: @breakpoint1) {
  .plane, .plane-container  {
    width: 140px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/library/rainSplash.vue